import React, { Component } from 'react';
import Vitae from '../../common/generateCurriculumVitae';
import UserSider from '../UserSider';

class GenerateCurriculumVitae extends Component {
    render() {
        return (
            <div className="content">
                <UserSider selectKey='userInfo' openKeys={['sub1']}/>
                <div className="main">
                    <div className="main-content">
                        <Vitae type="user" />
                    </div>
                </div>
            </div>
        );
    }
}

export default GenerateCurriculumVitae;


// WEBPACK FOOTER //
// ./src/components/user/generateCurriculumVitae/index.js